/**
 * Event data registry
 * Add new event data files here to make them available in the inserter
 */

import { LegacyEventData } from './LegacyEventData';
import {
  LegacyEvents2025Records,
  WSGAmericasMeeting2025Record,
  WSGBankingFinanceGroupMeeting2025EuropeRecord,
  WSGEuropeanMeeting2025Record,
  WSGIBAEuropeanMALuncheon2025Record,
} from './LegacyEvents2025';

export interface EventDataGroup {
  id: string;
  name: string;
  records: LegacyEventData[];
}

export const EVENT_DATA_REGISTRY: EventDataGroup[] = [
  {
    id: 'legacy-events-2025',
    name: 'Legacy Events 2025',
    records: LegacyEvents2025Records,
  },
  {
    id: 'wsg-european-meeting-2025',
    name: 'WSG European Meeting 2025',
    records: WSGEuropeanMeeting2025Record,
  },
  {
    id: 'wsg-americas-meeting-2025',
    name: 'WSG Americas Meeting 2025',
    records: WSGAmericasMeeting2025Record,
  },
  {
    id: 'wsg-iba-european-ma-luncheon-2025',
    name: 'WSG IBA European M&A Luncheon 2025',
    records: WSGIBAEuropeanMALuncheon2025Record,
  },
  {
    id: 'wsg-banking-finance-group-meeting-2025-europe',
    name: 'WSG Banking & Finance Group Meeting 2025 - Europe',
    records: WSGBankingFinanceGroupMeeting2025EuropeRecord,
  },
];
